import React, { useState, useRef } from "react";

import {
  useMutation,
  useQueryClient,
} from '@tanstack/react-query'
import { useParams } from 'react-router-dom';

import swal from "sweetalert";
import * as api from '../../../actions/api';
import StockTakeFormData from './StockTakeFormData.js';

import { format } from 'date-fns';
import encryptionService from "../../../services/encryptionService";
const AddStockTake = (props) => {
  //get DispensingLanguage
const DispensingLanguage =JSON.parse(localStorage.getItem("DispensingLanguage"));
const lan = localStorage.getItem('LangCode');
const menukey = "stock-take";
const FacilityId=localStorage.getItem('FacilityId');

const UserInfo = encryptionService.decryptUserInfo();
const UserName = UserInfo == 0 ? "" : UserInfo[0].name;

const [selectedDate, setSelectedDate] = useState(
  //new Date()
  format(new Date(), 'yyyy-MM-dd')
);

const [formData, setFormData] = useState({
  StockTakeDate: selectedDate,
  CompleteDate: selectedDate,
  IsCompleted:0,
  ManyJsonSave:"",
  "FacilityId":FacilityId,
  ItemGroupId:props.match.params.id, //Get the url send id
  PreparedBy: "",
  ApprovedBy: "",
  StockTakeId: "",
});

const [ManyTableData, setManyTableData] = useState( []);
const [updatedDetailGridData, setUpdatedDetailGridData] = useState([]);

  const handleRDateChange = (date, field) => {
    
    let newDate;
    if(date==null){
     newDate=date;
    }else{
      newDate = format(new Date(date), 'yyyy-MM-dd');
    }
    setFormData({ ...formData, [field]: newDate });
    setErrorObject({ ...errorObject, [field]: null });
  };

  const [errorObject, setErrorObject] = useState({});
  const saveInFlightRef = useRef(false);

  const { id } = useParams();
  const queryClient = useQueryClient();

  const { isLoading: isSaveMutating, mutate } = useMutation(api.saveStockTakeInv, {
    onSuccess: (data) => {
      if (data.status == 200) {
        let route = `/${menukey}/edit/${data.StockTakeId}`;
        props.history.push(route);

        props.openNoticeModal({
          isOpen: true,
          msg: data.message,
          msgtype: data.success,
        });
      } else {
        props.openNoticeModal({
          isOpen: true,
          msg: data.message,
          msgtype: data.success,
        });
      }
    }
  })

  const runSaveStockTake = (payload) => {
    if (saveInFlightRef.current) return;
    saveInFlightRef.current = true;
    mutate(payload, {
      onSettled: () => {
        saveInFlightRef.current = false;
      },
    });
  };

  const handleAdd = (NonOrderProductData) => {
    setManyTableData(NonOrderProductData);
    setUpdatedDetailGridData(NonOrderProductData);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    
      let data = { ...formData };
      data[name] = value;
      setFormData(data);
   


    setErrorObject({ ...errorObject, [name]: null });
  };


  const handleReset = () => {
    setFormData({
      StockTakeDate: selectedDate,
      CompleteDate: selectedDate,
      IsCompleted: 0,
      ManyJsonSave: "",
      FacilityId: FacilityId,
      ItemGroupId: props.match.params.id,
      PreparedBy: "",
      ApprovedBy: "",
      StockTakeId: "",
    });
  };

  const validateForm = (formData) => {
    let validateFields = ["StockTakeDate", "CompleteDate","PreparedBy","ApprovedBy"];
    let errorData = {}
    let isValid = true
    validateFields.map((field) => {
      if (!formData[field]) {
        errorData[field] = DispensingLanguage[lan][menukey]['field is Required !']
        isValid = false
      }
    })
    setErrorObject(errorData);
    return isValid
  }

  const handleSubmit = async (e) => {
    if (saveInFlightRef.current || isSaveMutating) return;
    if (validateForm(formData)) {
      runSaveStockTake(formData);
    }
  };

  return (
    <>
      <StockTakeFormData 
      errorObject={errorObject} 
      addProductForm={true} 
      formData={formData} 
      handleChange={handleChange}  
      handleReset={handleReset} 
      handleSubmit={handleSubmit} 
      ManyTableData={updatedDetailGridData}
      handleAdd={handleAdd}
      handleRDateChange={handleRDateChange} 
      selectedDate={selectedDate} 
      
      {...props}
      isSubmitting={isSaveMutating}
       />
    </>
  );
};

export default AddStockTake;